import {ThemeOptions} from '@mui/material';

export const MuiSelect: ThemeOptions['components'] = {
  MuiSelect: {
    defaultProps: {
      native: true
    },
    styleOverrides: {
      icon: {
        fill: '#0C55B8'
      }
    }
  },
  MuiNativeSelect: {
    styleOverrides: {
      icon: {
        fill: '#0C55B8'
      }
    }
  }
};
